import { Width } from '../types'

/**
 * resolves a {@link Width} into a string or number
 *
 * @param records
 * @param width
 */
export function getWidth<T>(records: T[] | undefined, width: Width<T>) {
  if (typeof width === 'function') return width(records ?? [])
  return width
}
